const TitleStripe = ({ children, className }) => {
  return (
    <div
      className={`px-2 bg-gray-200 font-semibold mt-5 text-xl leading-none py-2 ${className}`}
      style={{ fontVariant: "small-caps", boxSizing: "border-box" }}
    >
      {children}
    </div>
  );
};

export default TitleStripe;
